// "Chybí tvoje velikost?" sheet on the product page: markup and docs in snippets/pk-size-alts.liquid.
(function () {
  if (customElements.get('pk-size-alts')) return;

  const BELL = '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path fill="currentColor" d="M12 22a2 2 0 0 0 2-2h-4a2 2 0 0 0 2 2zm6-6v-5a6 6 0 0 0-5-5.92V4a1 1 0 1 0-2 0v1.08A6 6 0 0 0 6 11v5l-2 2v1h16v-1l-2-2z"/></svg>';
  const MAX_CARDS = 8;

  // "37 1/3" -> 37.33, "42.5" -> 42.5; clothing sizes in their usual order after the numbers
  const LETTERS = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL'];
  function sizeValue(size) {
    const parts = String(size).trim().replace(',', '.').split(/\s+/);
    let value = parseFloat(parts[0]);
    if (Number.isNaN(value)) {
      const letter = LETTERS.indexOf(String(size).trim().toUpperCase());
      return letter === -1 ? 9999 : 1000 + letter;
    }
    const fraction = parts[1] && parts[1].match(/^(\d+)\/(\d+)$/);
    if (fraction) value += Number(fraction[1]) / Number(fraction[2]);
    return value;
  }

  function money(cents) {
    // In the visitor's currency, formatted like the rest of the shop (window.pkMoney, layout/theme.liquid)
    if (window.pkMoney) return window.pkMoney(cents);
    return Math.round(cents / 100).toLocaleString('cs-CZ').replace(/ /g, ' ') + ' Kč';
  }

  // Texts come from the theme's language files (window.pkT, layout/theme.liquid); the Czech
  // fallback keeps everything working if a key is ever missing. [name] = a value filled in here.
  function tr(key, fallback, vars) {
    let text = (window.pkT && window.pkT[key]) || fallback;
    if (vars) Object.keys(vars).forEach((name) => { text = text.split('[' + name + ']').join(vars[name]); });
    return text;
  }

  function escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  function track(name) {
    if (typeof window.clarity === 'function') window.clarity('event', name);
  }

  class PkSizeAlts extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.titleEl = this.querySelector('[data-alts-title]');
      this.subEl = this.querySelector('[data-alts-sub]');
      this.sizesEl = this.querySelector('[data-alts-sizes]');
      this.noteEl = this.querySelector('[data-alts-note]');
      this.resultsEl = this.querySelector('[data-alts-results]');
      this.here = new Set(this.dataset.here.split('|').filter(Boolean));
      this.variants = new Map(
        this.dataset.variants.split('|').filter(Boolean).map((pair) => {
          const i = pair.indexOf(':');
          return [pair.slice(i + 1), pair.slice(0, i)];
        })
      );

      this.onOpen = (event) => this.open((event.detail && event.detail.size) || null);
      document.addEventListener('pk-size-alts:open', this.onOpen);
      // Start loading the moment a finger or the pointer lands on the tile or a sold-out size,
      // so the sizes are usually there by the time the sheet opens
      this.onWarm = (event) => {
        if (event.target.closest && event.target.closest('[data-alert-tile], [data-sold-out], [data-quick][data-single]')) this.load().catch(() => {});
      };
      document.addEventListener('pointerdown', this.onWarm, { passive: true });
      document.addEventListener('focusin', this.onWarm);

      // Where the sheet is likely to be used (three sizes or fewer in stock, or sold-out sizes on
      // the page), load quietly once the sizes come into view: the endpoint takes a moment to build
      const tile = document.querySelector('[data-alert-tile]');
      const likely = this.here.size <= 3 || document.querySelector('[data-variant-container] [data-sold-out]');
      if (tile && likely && 'IntersectionObserver' in window) {
        const idle = window.requestIdleCallback || ((fn) => setTimeout(fn, 200));
        this.warmObserver = new IntersectionObserver((entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          this.warmObserver.disconnect();
          idle(() => this.load().catch(() => {}));
        });
        this.warmObserver.observe(tile);
        // Phones: the size row above the grid is what is on screen first
        const single = document.querySelector('[data-quick][data-single]');
        if (single) this.warmObserver.observe(single);
      }
      document.documentElement.dataset.pkSizeAlts = 'ready';

      this.querySelector('[data-alts-close]').addEventListener('click', () => this.close());
      this.dialog.addEventListener('cancel', (event) => {
        event.preventDefault();
        this.close();
      });
      // A tap on the dimmed page closes; the dialog element itself covers only the panel
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.close();
      });
      this.sizesEl.addEventListener('click', (event) => {
        const button = event.target.closest('[data-size]');
        if (button) this.pick(button.dataset.size);
      });
      this.resultsEl.addEventListener('click', (event) => {
        if (event.target.closest('[data-alts-alert]')) {
          const size = this.size;
          this.close();
          const id = this.variants.get(size) || 'extra:' + size;
          document.dispatchEvent(new CustomEvent('stock-alert:open', { detail: { tab: 'back_in_stock', variantId: id } }));
          track('pk_alt_alert');
        } else if (event.target.closest('.pk-alts__card')) {
          track('pk_alt_product');
        }
      });
    }

    disconnectedCallback() {
      document.removeEventListener('pk-size-alts:open', this.onOpen);
      document.removeEventListener('pointerdown', this.onWarm);
      document.removeEventListener('focusin', this.onWarm);
      this.warmObserver?.disconnect();
    }

    load() {
      if (!this.request) {
        const key = 'pk_size_alts:' + this.dataset.url;
        let cached = null;
        try {
          cached = JSON.parse(sessionStorage.getItem(key) || 'null');
        } catch (_) {}
        this.request = cached
          ? Promise.resolve(cached)
          : fetch(this.dataset.url, { credentials: 'same-origin' })
              .then((response) => {
                if (!response.ok) throw new Error('Size alternatives ' + response.status);
                return response.json();
              })
              .then((data) => {
                try {
                  sessionStorage.setItem(key, JSON.stringify(data));
                } catch (_) {}
                return data;
              });
        this.request.catch(() => {
          this.request = null;
        });
      }
      return this.request;
    }

    open(size) {
      this.trigger = document.activeElement;
      this.size = null;
      this.dialog.classList.remove('is-results');
      this.resultsEl.hidden = true;
      this.titleEl.textContent = tr('altsTitle', 'Jakou velikost hledáš?');
      this.subEl.textContent = tr('altsSub', 'Ukážeme ti podobné modely, které ji máme skladem.');
      if (this.data) this.renderSizes(this.sizesFrom(this.data));
      else this.sizesEl.innerHTML = '<span class="pk-alts__size is-loading" aria-hidden="true"></span>'.repeat(10);
      this.noteEl.hidden = this.here.size === 0;

      if (!this.dialog.open) {
        document.documentElement.classList.add('pk-alts-lock');
        this.dialog.showModal();
        requestAnimationFrame(() => requestAnimationFrame(() => this.dialog.classList.add('is-open')));
      }
      track(size ? 'pk_alt_open_soldout' : 'pk_alt_open');

      if (size) this.pick(size);
      this.load()
        .then((data) => {
          this.data = data;
          if (!this.dialog.open) return;
          // Whatever the visitor has chosen in the meantime is what gets filled in
          if (this.size) this.pick(this.size);
          else this.renderSizes(this.sizesFrom(data));
        })
        .catch(() => {
          this.data = { title: '', url: this.dataset.filterUrl.split('?')[0], products: [] };
          if (this.size) this.pick(this.size);
          else this.renderSizes(this.sizesFrom(this.data));
        });
    }

    close() {
      if (!this.dialog.open) return;
      this.dialog.classList.remove('is-open');
      const finish = () => {
        this.dialog.close();
        document.documentElement.classList.remove('pk-alts-lock');
        if (this.trigger && this.trigger.focus) this.trigger.focus({ preventScroll: true });
      };
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduced) return finish();
      let done = false;
      const once = () => {
        if (done) return;
        done = true;
        finish();
      };
      this.dialog.addEventListener('transitionend', once, { once: true });
      setTimeout(once, 400);
    }

    // Every size this product or the collection has in stock, in shoe-size order
    sizesFrom(data) {
      const all = new Set(this.here);
      if (data) {
        for (const product of data.products) for (const variant of product.v) all.add(variant[1]);
      }
      return Array.from(all).sort((a, b) => sizeValue(a) - sizeValue(b));
    }

    renderSizes(sizes) {
      this.sizesEl.innerHTML = sizes
        .map((size) => {
          const here = this.here.has(size) ? ' is-here' : '';
          const pressed = size === this.size ? 'true' : 'false';
          const label = this.here.has(size) ? escapeHtml(size) + ', skladem u tohoto modelu' : escapeHtml(size);
          return `<button type="button" class="pk-alts__size${here}" data-size="${escapeHtml(size)}" aria-pressed="${pressed}" aria-label="${label}">${escapeHtml(size)}</button>`;
        })
        .join('');
    }

    pick(size) {
      // A size this product has: choose it on the page, nothing else to show
      if (this.here.has(size)) {
        const id = this.variants.get(size);
        const button = id && document.querySelector('[data-variant-container] [data-variant-id="' + id + '"]');
        this.close();
        if (button) button.click();
        track('pk_alt_here');
        return;
      }

      this.size = size;
      this.dialog.classList.add('is-results');
      this.noteEl.hidden = true;
      this.titleEl.textContent = tr('altsSizeMissing', 'Velikost [size] tu teď není', { size });
      this.renderSizes(this.sizesFrom(this.data));
      this.resultsEl.hidden = false;
      const current = this.sizesEl.querySelector('[aria-pressed="true"]');
      if (current) current.scrollIntoView({ block: 'nearest', inline: 'center' });

      if (!this.data) {
        this.subEl.textContent = tr('altsSearching', 'Hledám podobné modely…');
        this.resultsEl.innerHTML = '<div class="pk-alts__row" aria-hidden="true"><span class="pk-alts__skeleton"></span><span class="pk-alts__skeleton"></span><span class="pk-alts__skeleton"></span></div>' + this.alertHtml(size);
        return;
      }
      track('pk_alt_pick');

      const matches = [];
      for (const product of this.data.products) {
        if (product.h === this.dataset.handle) continue;
        const variant = product.v.find((v) => v[1] === size);
        if (variant) matches.push({ product, variant });
      }
      const collectionTitle = this.data.title;
      const allUrl = this.dataset.filterUrl + encodeURIComponent(size);

      if (!matches.length) {
        this.subEl.textContent = collectionTitle ? tr('altsNoneIn', 'Zatím ji nemáme ani u jiného modelu z [collection].', { collection: collectionTitle }) : tr('altsLoadFailed', 'Podobné modely se teď nepodařilo načíst.');
        this.resultsEl.innerHTML = this.alertHtml(size) + `<a class="pk-alts__all" href="${escapeHtml(this.data.url)}">${tr('altsBrowse', 'Prohlédnout [collection]', { collection: collectionTitle ? escapeHtml(collectionTitle) : tr('altsWholeCollection', 'celou kolekci') })}</a>`;
        return;
      }

      this.subEl.textContent = tr('altsFound', 'Ale máme ji skladem u těchto modelů:');
      const cards = matches
        .slice(0, MAX_CARDS)
        .map(({ product, variant }) => {
          const image = product.i ? `<img src="${escapeHtml(product.i)}" alt="" loading="lazy" width="360" height="360">` : '';
          return `<a class="pk-alts__card" href="${escapeHtml(product.u)}?variant=${variant[0]}"><span class="pk-alts__img">${image}</span><span class="pk-alts__name">${escapeHtml(product.t)}</span><span class="pk-alts__price"><span class="pk-alts__chip">${escapeHtml(size)}</span>${money(variant[2])}</span></a>`;
        })
        .join('');
      const more = `<a class="pk-alts__all" href="${escapeHtml(allUrl)}">${tr('altsAllInSize', 'Všechny [collection] ve velikosti [size] ([count])', { collection: escapeHtml(collectionTitle), size: escapeHtml(size), count: matches.length })}</a>`;
      this.resultsEl.innerHTML = `<div class="pk-alts__row">${cards}</div>` + this.alertHtml(size) + more;
    }

    // Only when the size picker has the alert dialog switched on
    alertHtml(size) {
      if (!document.querySelector('.is-alerts-active')) return '';
      return `<button type="button" class="pk-alts__alert" data-alts-alert>${BELL}${tr('altsNotify', 'Dej mi vědět, až bude [size] u [product]', { size: escapeHtml(size), product: escapeHtml(this.dataset.short || this.dataset.title) })}</button>`;
    }
  }

  customElements.define('pk-size-alts', PkSizeAlts);
})();
